var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZoomIn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.572,
    height: 17.496,
    viewBox: "0 0 17.572 17.496",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28240",
    "data-name": "Group 28240",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-magnifier-2327127"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23050",
    "data-name": "Path 23050",
    d: "M150.418,344.4a.939.939,0,0,1-.675-.3l-4.135-4.4c.007,0,.01-.01.017-.014.094-.073.18-.145.263-.218.017-.017.035-.031.055-.049.083-.073.163-.145.235-.222s.149-.156.222-.235a.684.684,0,0,1,.049-.052c.073-.083.142-.17.215-.263,0-.007.01-.01.014-.017l4.4,4.135a.938.938,0,0,1,.3.675.946.946,0,0,1-.959.959Z",
    transform: "translate(-134.805 -327.902)",
    fill: "#003975",
    stroke: "#003975",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23051",
    "data-name": "Path 23051",
    d: "M248.181,85.556a6.153,6.153,0,0,1-.585.686,6.575,6.575,0,0,1-.686.585,6.314,6.314,0,0,1-8.211-.585,6.292,6.292,0,0,1,8.9-8.9,6.315,6.315,0,0,1,.585,8.215Z",
    transform: "translate(-236.857 -75.502)",
    fill: "none",
    stroke: "#003975",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28239",
    "data-name": "Group 28239",
    transform: "translate(3.933 3.939)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1031",
    "data-name": "Line 1031",
    y2: 4.786,
    transform: "translate(2.393)",
    fill: "none",
    stroke: "#003975",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1032",
    "data-name": "Line 1032",
    x2: 4.786,
    transform: "translate(0 2.393)",
    fill: "none",
    stroke: "#003975",
    strokeLinecap: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn);
export default __webpack_public_path__ + "static/media/zoomIn.cbb63f83af8246d6c92d60a82e58b36a.svg";
export { ForwardRef as ReactComponent };